import { Link } from "react-router-dom";
import { Loader2, MessageCircle, Send } from "lucide-react";
import { appointmentText, placeOf } from "../../lib/bookingMessage";
import { useLocalePath } from "../site/LangRouting";
import { StepError } from "./WizardBits";

const Row = ({ label, value, onEdit, editLabel, testid }) => (
  <div className="grid grid-cols-[1fr_auto] sm:grid-cols-[160px_1fr_auto] gap-x-4 gap-y-1 py-4 border-b border-white/[0.08]">
    <dt className="text-[11px] tracking-[0.25em] uppercase text-zinc-500 sm:pt-0.5 col-span-1">{label}</dt>
    <dd data-testid={testid} className="text-[15px] text-white col-span-2 sm:col-span-1 row-start-2 sm:row-start-auto break-words">{value}</dd>
    <button type="button" onClick={onEdit} className="row-start-1 col-start-2 sm:col-start-3 text-[12px] tracking-[0.15em] uppercase text-gold/80 hover:text-gold justify-self-end">{editLabel}</button>
  </div>
);

export const StepReview = ({ c, w, lang, privacyLabel }) => {
  const r = c.review, v = w.data;
  const lp = useLocalePath();
  const contact = [v.name, v.phone, v.email, c.details.contacts[v.contact]].filter(Boolean).join(" · ");
  return (
    <div>
      <dl data-testid="wizard-summary" className="border-t border-white/[0.08]">
        <Row label={r.service} value={c.services[v.service]?.title} onEdit={() => w.goTo(0)} editLabel={r.edit} testid="wizard-summary-service" />
        <Row label={r.location} value={placeOf(v)} onEdit={() => w.goTo(1)} editLabel={r.edit} testid="wizard-summary-location" />
        <Row label={r.appointment} value={appointmentText(v, c, lang)} onEdit={() => w.goTo(2)} editLabel={r.edit} testid="wizard-summary-appointment" />
        <Row label={r.contact} value={contact} onEdit={() => w.goTo(3)} editLabel={r.edit} testid="wizard-summary-contact" />
      </dl>
      <label data-testid="wizard-consent" className="mt-6 flex items-start gap-3 text-[13px] text-zinc-400 leading-relaxed cursor-pointer select-none">
        <input type="checkbox" checked={v.consent} onChange={(e) => w.set("consent", e.target.checked)} data-testid="wizard-consent-checkbox" className="mt-0.5 w-4 h-4 accent-[#d4af37] shrink-0" />
        <span>{r.consent} <Link to={lp("/datenschutz")} className="text-gold hover:underline">{privacyLabel}</Link></span>
      </label>
      <StepError text={w.errors.consent || w.errors.submit} testid="wizard-error-submit" />
      <div className="mt-7 flex flex-col sm:flex-row gap-3">
        <button type="button" data-testid="wizard-submit-whatsapp" disabled={w.submitting} onClick={() => w.submit("wa")}
          className="flex-1 inline-flex items-center justify-center gap-3 bg-gold text-black px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-semibold hover:bg-[#E5C378] transition-colors disabled:opacity-60">
          {w.submitting ? <Loader2 size={16} className="animate-spin" /> : <MessageCircle size={16} />} {w.submitting ? c.nav.saving : r.primary}
        </button>
        <button type="button" data-testid="wizard-submit-form" disabled={w.submitting} onClick={() => w.submit("form")}
          className="inline-flex items-center justify-center gap-3 border border-white/20 text-white px-6 py-4 text-[12px] tracking-[0.22em] uppercase hover:border-gold hover:text-gold transition-colors disabled:opacity-60">
          <Send size={14} /> {r.secondary}
        </button>
      </div>
      <p data-testid="wizard-whatsapp-hint" className="mt-4 text-[13px] text-zinc-400 leading-relaxed">{r.hint}</p>
      {w.photos.length > 0 && <p className="mt-2 text-[12px] text-zinc-500">{r.photosNote}</p>}
    </div>
  );
};
